/* Smll Me blend core: oils, fixed blend names + stories, cart, collection, share card, party + fireworks. Used by Blend Studio + Scent Quiz. */
(function () {
  if (window.SmllBlends) return;
  var ADJ = { mandarin: 'Golden', lime: 'Coastal', bergamot: 'Velvet', lemongrass: 'Wild', teatree: 'Clean', lemontea: 'Sunlit', niaouli: 'Misty', basil: 'Green', thyme: 'Rustic', winter: 'Frosted' };
  var NOUN = { rose: ['Bloom', 'Ember'], marjoram: ['Meadow', 'Hearth'], clary: ['Reverie', 'Grove'], melissa: ['Nectar', 'Orchard'], fennel: ['Garden', 'Trail'] };
  var ORDER_T = ['mandarin', 'lime', 'bergamot', 'lemongrass', 'teatree', 'lemontea', 'niaouli', 'basil', 'thyme', 'winter'];
  var ORDER_M = ['rose', 'marjoram', 'clary', 'melissa', 'fennel'];
  // The story behind each name: the first word comes from the top note, the second from the middle + base notes.
  var STORY_A = {
    mandarin: 'Golden is the last hour of sun, when the light turns honey-colored and everything slows down.',
    lime: 'Coastal is a morning by the sea: salt in the air, bare feet, a cold drink with a squeeze of lime.',
    bergamot: 'Velvet is an Earl Grey afternoon: soft light, a good chair and nowhere to be.',
    lemongrass: 'Wild is tall grass after the rain, the kind of fresh you only find off the trail.',
    teatree: 'Clean is a just-made bed and every window open wide.',
    lemontea: 'Sunlit is a bright kitchen at 8 a.m., lemons on the counter and the whole day ahead.',
    niaouli: 'Misty is an early walk before the fog lifts, when the air feels cool and new.',
    basil: 'Green is a windowsill herb garden, leaves you brush with your fingers as you pass.',
    thyme: 'Rustic is a farmhouse table, a wood stove and bread warming in the oven.',
    winter: 'Frosted is the first cold morning of the year, your breath in the air and a crisp, minty bite.'
  };
  var STORY_N = {
    rose: ['Bloom is a garden in full flower, rose petals and sweet blossoms opening all at once.', 'Ember is a single rose left by the fire: soft petals over glowing, smoky wood.'],
    marjoram: ['Meadow is an open field of warm herbs and wildflowers, soft and sun-warmed.', 'Hearth is coming home: warm herbs, a crackling fire and a little wood smoke.'],
    clary: ['Reverie is a daydream that drifts somewhere soft, musky and sweetly floral.', 'Grove is a quiet path under old trees, herbal air above and earthy roots below.'],
    melissa: ['Nectar is the sweetest part of the flower, honey and lemon blossom together.', 'Orchard is late-season fruit trees, honeyed lemon over dark, earthy soil.'],
    fennel: ['Garden is a kitchen garden in bloom, sweet anise leaves beside rich flowers.', 'Trail is a hike that ends at a campfire, sweet herbs underfoot and smoke on the breeze.']
  };
  var MOMENT = { rose: ['Afternoon', 'Evening'], marjoram: ['Afternoon', 'Evening'], clary: ['Night', 'Evening'], melissa: ['Morning', 'Afternoon'], fennel: ['Morning', 'Evening'] };
  var SEASON = { mandarin: 'Late summer', lime: 'Summer', bergamot: 'Autumn', lemongrass: 'Spring', teatree: 'All year', lemontea: 'Spring', niaouli: 'Autumn', basil: 'Spring', thyme: 'Autumn', winter: 'Winter' };
  var BADGES = [
    { n: 1, t: 'First Drop' }, { n: 5, t: 'Apprentice' }, { n: 15, t: 'Scent Explorer' }, { n: 40, t: 'Perfumer' }, { n: 100, t: 'Master Blender' }
  ];

  var SB = {
    oils: [], byK: {}, BADGES: BADGES,
    load: function () {
      if (SB.oils.length) return SB;
      try { SB.oils = JSON.parse(document.getElementById('smll-oils').textContent); } catch (e) { SB.oils = []; }
      SB.oils.forEach(function (o) { SB.byK[o.k] = o; });
      return SB;
    },
    list: function (note) { return SB.oils.filter(function (o) { return o.note === note; }); },
    name: function (t, m, b) {
      var a = ADJ[t], n = NOUN[m];
      if (!a || !n) return [t, m, b].map(function (k) { return SB.byK[k] ? SB.byK[k].name : ''; }).join(' + ');
      return a + ' ' + n[b === 'vetiver' ? 1 : 0];
    },
    mood: function (t, m, b) {
      var o = [SB.byK[t], SB.byK[m], SB.byK[b]]; if (!o[0] || !o[1] || !o[2]) return '';
      return o[0].words + ', with a ' + o[1].words.toLowerCase() + ' heart and a ' + o[2].words.toLowerCase() + ' finish.';
    },
    // number (1-100), rarity, story and best moment for every mix
    info: function (t, m, b) {
      var ti = ORDER_T.indexOf(t), mi = ORDER_M.indexOf(m), bi = b === 'vetiver' ? 1 : 0;
      if (ti < 0 || mi < 0) return null;
      var no = ti * 10 + mi * 2 + bi + 1;
      var prem = (m === 'rose' || m === 'melissa' ? 1 : 0) + bi;
      return {
        no: no, label: 'No. ' + ('00' + no).slice(-3), rarity: ['Common', 'Rare', 'Legendary'][prem], tier: prem,
        story: STORY_A[t] + ' ' + STORY_N[m][bi], when: MOMENT[m][bi] + ' · ' + SEASON[t]
      };
    },
    valid: function (t, m, b) {
      var o = [SB.byK[t], SB.byK[m], SB.byK[b]];
      return !!(o[0] && o[1] && o[2] && o[0].note === 'top' && o[1].note === 'middle' && o[2].note === 'base');
    },
    code: function (t, m, b) { return [t, m, b].join('.'); },
    parse: function (s) { var p = String(s || '').split('.'); return (p.length === 3 && SB.valid(p[0], p[1], p[2])) ? p : null; },
    link: function (t, m, b, extra) {
      var u = location.origin + '/pages/blend?b=' + encodeURIComponent(SB.code(t, m, b));
      if (extra) Object.keys(extra).forEach(function (k) { if (extra[k]) u += '&' + k + '=' + encodeURIComponent(extra[k]); });
      return u;
    },
    price: function (t, m, b) { return [t, m, b].reduce(function (s, k) { return s + (SB.byK[k] ? SB.byK[k].price : 0); }, 0); },
    money: function (c) { return '$' + (c / 100).toFixed(2); },
    esc: function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); },
    random: function () {
      var r = function (a) { return a[Math.floor(Math.random() * a.length)].k; };
      var T = SB.list('top').filter(function (o) { return o.avail; }), M = SB.list('middle').filter(function (o) { return o.avail; }), B = SB.list('base').filter(function (o) { return o.avail; });
      if (!T.length || !M.length || !B.length) return null;
      return [r(T), r(M), r(B)];
    },
    all: function () {
      var out = [];
      SB.list('top').forEach(function (t) { SB.list('middle').forEach(function (m) { SB.list('base').forEach(function (b) { out.push([t.k, m.k, b.k]); }); }); });
      return out;
    },
    found: function () { try { return JSON.parse(localStorage.getItem('smllFound') || '[]'); } catch (e) { return []; } },
    discover: function (t, m, b) {
      var c = SB.code(t, m, b), f = SB.found();
      if (f.indexOf(c) !== -1) return false;
      f.push(c); try { localStorage.setItem('smllFound', JSON.stringify(f)); } catch (e) {}
      return true;
    },
    badgeFor: function (n) { var b = null; BADGES.forEach(function (x) { if (n >= x.n) b = x; }); return b; },
    addTrio: function (t, m, b, props) {
      var label = SB.name(t, m, b), inf = SB.info(t, m, b);
      var items = [t, m, b].map(function (k) { var p = { Blend: label + (inf ? ' (' + inf.label + ')' : '') }; if (props) Object.keys(props).forEach(function (x) { if (props[x]) p[x] = props[x]; }); return { id: SB.byK[k].id, quantity: 1, properties: p }; });
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (res) {
          SB.toast(label + ' added to your cart');
          if (window.smllOpenCart && window.matchMedia('(max-width: 749px)').matches) setTimeout(window.smllOpenCart, 500);
          else setTimeout(function () { location.href = '/cart'; }, 900);
          return res;
        })
        .catch(function (e) { SB.toast('Sorry, one of these oils is out of stock right now.'); throw e; });
    },
    toast: function (msg) {
      SB._css();
      var t = document.getElementById('smll-toast');
      if (!t) { t = document.createElement('div'); t.id = 'smll-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
      t.textContent = msg; t.classList.add('is-in'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-in'); }, 2600);
    },
    card: function (t, m, b, opts) {
      opts = opts || {};
      var W = 1080, H = 1350, c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d');
      var head = (getComputedStyle(document.body).getPropertyValue('--font-heading-family') || '').trim() || 'Georgia, serif';
      var bodyF = (getComputedStyle(document.body).getPropertyValue('--font-body-family') || '').trim() || 'Helvetica, Arial, sans-serif';
      var g = x.createLinearGradient(0, 0, W, H); g.addColorStop(0, '#1b5a55'); g.addColorStop(.55, '#0f3a38'); g.addColorStop(1, '#0b2a29');
      x.fillStyle = g; x.fillRect(0, 0, W, H);
      [[t, 180, 260], [m, 900, 520], [b, 260, 1150]].forEach(function (a) {
        var o = SB.byK[a[0]]; if (!o) return;
        var rg = x.createRadialGradient(a[1], a[2], 10, a[1], a[2], 420); rg.addColorStop(0, o.color + '55'); rg.addColorStop(1, o.color + '00');
        x.fillStyle = rg; x.fillRect(0, 0, W, H);
      });
      x.textAlign = 'center';
      var inf = SB.info(t, m, b); var kick = (opts.kicker || 'SMLL ME BLEND STUDIO') + (inf ? '  ·  ' + inf.label.toUpperCase() + '  ·  ' + inf.rarity.toUpperCase() : '');
      x.fillStyle = '#ecc94b'; x.font = '600 28px ' + bodyF; x.fillText(kick.split('').join(String.fromCharCode(8202)), W / 2, 120);
      var bx = W / 2 - 150, by = 190, s = 2.5;
      x.save(); x.translate(bx, by); x.scale(s, s);
      var bottle = new Path2D('M44 30h32v18c0 4 3 7 7 9 12 6 21 17 21 33v72c0 9-7 16-16 16H32c-9 0-16-7-16-16V90c0-16 9-27 21-33 4-2 7-5 7-9z');
      x.fillStyle = '#0b2120'; x.fillRect(47, 8, 26, 24);
      x.save(); x.clip(bottle);
      x.fillStyle = 'rgba(255,255,255,.08)'; x.fillRect(0, 0, 120, 190);
      var y = 174;
      [[b, 1], [m, 2], [t, 3]].forEach(function (a) { var o = SB.byK[a[0]]; var h = 20 * a[1]; y -= h; x.fillStyle = o ? o.color : '#888'; x.fillRect(0, y, 120, h + 2); });
      var sh = x.createLinearGradient(0, 0, 120, 0); sh.addColorStop(0, 'rgba(255,255,255,0)'); sh.addColorStop(.18, 'rgba(255,255,255,.35)'); sh.addColorStop(.3, 'rgba(255,255,255,0)');
      x.fillStyle = sh; x.fillRect(0, 0, 120, 190);
      x.restore();
      x.strokeStyle = 'rgba(255,255,255,.6)'; x.lineWidth = 2; x.stroke(bottle);
      x.restore();
      var name = SB.name(t, m, b);
      x.fillStyle = '#ffffff'; x.font = '700 104px ' + head;
      SB._fit(x, name, W - 140, 104, head, 700); x.fillText(name, W / 2, 780);
      x.fillStyle = 'rgba(255,255,255,.85)'; x.font = 'italic 400 30px ' + bodyF;
      SB._wrap(x, inf ? inf.story : SB.mood(t, m, b), W / 2, 845, W - 220, 42);
      var rows = [[t, '3 drops'], [m, '2 drops'], [b, '1 drop']], ry = 1045;
      rows.forEach(function (r) {
        var o = SB.byK[r[0]]; if (!o) return;
        x.textAlign = 'left';
        x.fillStyle = o.color; x.beginPath(); x.arc(330, ry - 12, 16, 0, Math.PI * 2); x.fill();
        x.fillStyle = '#ecc94b'; x.font = '700 36px ' + bodyF; x.fillText(r[1], 370, ry);
        x.fillStyle = '#ffffff'; x.font = '400 36px ' + bodyF; x.fillText(o.name, 530, ry);
        ry += 62;
      });
      x.textAlign = 'center';
      if (opts.footer) { x.fillStyle = '#ecc94b'; x.font = '600 34px ' + bodyF; x.fillText(opts.footer, W / 2, 1245); }
      x.fillStyle = 'rgba(255,255,255,.75)'; x.font = '500 30px ' + bodyF; x.fillText('Make yours at smll.me/pages/blend', W / 2, 1300);
      return new Promise(function (res) { c.toBlob(function (bl) { res({ blob: bl, url: c.toDataURL('image/png') }); }, 'image/png'); });
    },
    _fit: function (x, txt, max, size, fam, wt) { while (x.measureText(txt).width > max && size > 40) { size -= 4; x.font = wt + ' ' + size + 'px ' + fam; } },
    _wrap: function (x, txt, cx, y, max, lh) {
      var words = String(txt).split(' '), line = '';
      words.forEach(function (w) { var test = line ? line + ' ' + w : w; if (x.measureText(test).width > max && line) { x.fillText(line, cx, y); line = w; y += lh; } else line = test; });
      if (line) x.fillText(line, cx, y);
    },
    share: function (t, m, b, opts) {
      opts = opts || {};
      var url = opts.url || SB.link(t, m, b), name = SB.name(t, m, b);
      var text = opts.text || ('My Smll Me blend is "' + name + '". Make yours:');
      return SB.card(t, m, b, opts).then(function (img) {
        var file = null; try { file = img.blob ? new File([img.blob], name.replace(/\s+/g, '-').toLowerCase() + '.png', { type: 'image/png' }) : null; } catch (e) {}
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
          return navigator.share({ files: [file], title: name, text: text + ' ' + url }).catch(function () {});
        }
        SB.modal(
          '<img src="' + img.url + '" alt="' + SB.esc(name) + ' blend card" style="width:100%;border-radius:16px;display:block">' +
          '<div class="sb-actions"><a class="sb-btn" download="' + SB.esc(name) + '.png" href="' + img.url + '">Save image</a>' +
          '<button type="button" class="sb-btn ghost" data-copy="' + SB.esc(url) + '">Copy link</button></div>' +
          (navigator.share ? '<button type="button" class="sb-btn ghost" data-native style="width:100%;margin-top:8px">Share link</button>' : ''),
          opts.title || 'Share your blend',
          function (box) {
            var n = box.querySelector('[data-native]'); if (n) n.onclick = function () { navigator.share({ title: name, text: text, url: url }).catch(function () {}); };
          }
        );
      });
    },
    copy: function (txt) {
      var done = function () { SB.toast('Link copied'); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, function () { prompt('Copy this link', txt); });
      else prompt('Copy this link', txt);
    },
    modal: function (html, title, onOpen) {
      SB._css();
      var wrap = document.createElement('div'); wrap.className = 'sb-modal';
      wrap.innerHTML = '<div class="sb-back" data-x></div><div class="sb-box" role="dialog" aria-modal="true" aria-label="' + SB.esc(title || '') + '"><div class="sb-head"><strong>' + SB.esc(title || '') + '</strong><button type="button" data-x aria-label="Close">&times;</button></div><div class="sb-body">' + html + '</div></div>';
      document.body.appendChild(wrap);
      requestAnimationFrame(function () { wrap.classList.add('is-open'); });
      var close = function () { wrap.classList.remove('is-open'); setTimeout(function () { wrap.remove(); }, 250); };
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-x]')) close();
        var cp = e.target.closest('[data-copy]'); if (cp) SB.copy(cp.getAttribute('data-copy'));
      });
      if (onOpen) onOpen(wrap, close);
      return { el: wrap, close: close };
    },
    _css: function () {
      if (document.getElementById('sb-css')) return;
      var s = document.createElement('style'); s.id = 'sb-css';
      s.textContent = '#smll-toast{position:fixed;left:50%;bottom:calc(var(--smll-tabs-h,0px) + 20px);transform:translate(-50%,30px);opacity:0;pointer-events:none;background:#0f3a38;color:#fff;padding:12px 18px;border-radius:999px;font-size:14px;font-weight:600;z-index:2147483600;transition:all .3s ease;box-shadow:0 8px 24px rgba(0,0,0,.2);max-width:90vw;text-align:center}#smll-toast.is-in{transform:translate(-50%,0);opacity:1}' +
        '.sb-modal{position:fixed;inset:0;z-index:2147483500;display:flex;align-items:flex-end;justify-content:center}.sb-back{position:absolute;inset:0;background:rgba(10,20,20,.5);opacity:0;transition:opacity .25s}.sb-box{position:relative;background:#fff;width:100%;max-width:460px;max-height:92vh;overflow:auto;border-radius:22px 22px 0 0;padding:0 16px calc(18px + env(safe-area-inset-bottom));transform:translateY(100%);transition:transform .3s cubic-bezier(.2,.8,.2,1)}' +
        '@media(min-width:750px){.sb-modal{align-items:center}.sb-box{border-radius:22px}}.sb-modal.is-open .sb-back{opacity:1}.sb-modal.is-open .sb-box{transform:none}' +
        '.sb-head{display:flex;align-items:center;justify-content:space-between;padding:14px 0 10px;position:sticky;top:0;background:#fff;z-index:1}.sb-head strong{font-size:17px;color:#1d2426}.sb-head button{border:0;background:#f2f5f4;width:34px;height:34px;border-radius:50%;font-size:22px;line-height:1;cursor:pointer;color:#1d2426}' +
        '.sb-actions{display:flex;gap:8px;margin-top:12px}.sb-btn{flex:1;display:block;text-align:center;border:0;border-radius:999px;padding:14px;font-size:15px;font-weight:700;cursor:pointer;background:#0f3a38;color:#fff;text-decoration:none}.sb-btn.ghost{background:#f2f5f4;color:#0f3a38}' +
        '.sb-fx{position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483450}' +
        '.sb-party{display:block!important;position:fixed;inset:0;pointer-events:none;z-index:2147483440;opacity:0;transition:opacity .35s;mix-blend-mode:normal;background:linear-gradient(120deg,#ff3cac,#784ba0,#2b86c5,#ecc94b,#ff7a59);background-size:400% 400%;animation:sbDisco 1.1s linear infinite}.sb-party.is-on{opacity:.32}' +
        '@keyframes sbDisco{0%{background-position:0% 50%;filter:hue-rotate(0)}100%{background-position:100% 50%;filter:hue-rotate(360deg)}}' +
        '.sb-flash{display:block!important;position:fixed;inset:0;pointer-events:none;z-index:2147483440;background:radial-gradient(circle at 50% 30%,rgba(255,236,170,.55),rgba(255,236,170,0) 60%);opacity:0}.sb-flash.go{animation:sbFlash .6s ease-out}@keyframes sbFlash{0%{opacity:1}100%{opacity:0}}' +
        '.sb-field{display:block;margin:0 0 10px}.sb-field span{display:block;font-size:12px;color:#6c7678;margin-bottom:4px}.sb-field input,.sb-field textarea{width:100%;box-sizing:border-box;border:1.5px solid #e8ecec;border-radius:12px;padding:12px;font-size:16px;line-height:1.3;font-family:inherit;color:#1d2426;background:#fff}.sb-field textarea{min-height:80px;resize:vertical}';
      document.head.appendChild(s);
    },

    // ---------- effects ----------
    _calm: function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; },
    _canvas: function () {
      var c = document.createElement('canvas'), d = Math.min(window.devicePixelRatio || 1, 2);
      c.className = 'sb-fx'; c.width = innerWidth * d; c.height = innerHeight * d;
      var x = c.getContext('2d'); x.scale(d, d); document.body.appendChild(c);
      return { c: c, x: x, W: innerWidth, H: innerHeight };
    },
    COLORS: ['#ecc94b', '#f4a259', '#e07a9b', '#9a86c8', '#5fa8b0', '#a8c94a', '#ffffff', '#ff7a59'],
    party: function (ms) {
      if (SB._calm()) return;
      ms = ms || 2300; SB._css();
      var ov = document.createElement('div'); ov.className = 'sb-party'; document.body.appendChild(ov);
      requestAnimationFrame(function () { ov.classList.add('is-on'); });
      var cv = SB._canvas(), x = cv.x, W = cv.W, H = cv.H, P = [], t0 = performance.now();
      function burst(px, py, n, up) {
        for (var i = 0; i < n; i++) {
          var a = up ? (-Math.PI / 2 + (Math.random() - .5) * 1.6) : Math.random() * Math.PI * 2, v = 6 + Math.random() * 10;
          P.push({ x: px, y: py, vx: Math.cos(a) * v, vy: Math.sin(a) * v - (up ? 4 : 0), s: 5 + Math.random() * 7, c: SB.COLORS[i % SB.COLORS.length],
            r: Math.random() * 6, vr: (Math.random() - .5) * .35, sh: i % 3, l: 1 });
        }
      }
      burst(W / 2, H * .6, 120, true);
      setTimeout(function () { burst(W * .15, H * .75, 70, true); burst(W * .85, H * .75, 70, true); }, 350);
      setTimeout(function () { burst(W / 2, H * .4, 90, false); }, 800);
      var rain = setInterval(function () { for (var i = 0; i < 6; i++) P.push({ x: Math.random() * W, y: -10, vx: (Math.random() - .5) * 2, vy: 2 + Math.random() * 3, s: 5 + Math.random() * 6, c: SB.COLORS[(Math.random() * 8) | 0], r: Math.random() * 6, vr: (Math.random() - .5) * .3, sh: i % 3, l: 1 }); }, 70);
      (function f(now) {
        var el = now - t0; x.clearRect(0, 0, W, H);
        P.forEach(function (p) {
          p.vy += .32; p.vx *= .985; p.x += p.vx; p.y += p.vy; p.r += p.vr; if (el > ms) p.l -= .025;
          x.save(); x.globalAlpha = Math.max(0, p.l); x.translate(p.x, p.y); x.rotate(p.r); x.fillStyle = p.c;
          if (p.sh === 0) x.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2);
          else if (p.sh === 1) { x.beginPath(); x.arc(0, 0, p.s / 2.6, 0, 6.3); x.fill(); }
          else { x.beginPath(); x.moveTo(0, -p.s / 2); x.lineTo(p.s / 2, p.s / 2); x.lineTo(-p.s / 2, p.s / 2); x.fill(); }
          x.restore();
        });
        P = P.filter(function (p) { return p.l > 0 && p.y < H + 40; });
        if (el > ms - 600) { clearInterval(rain); ov.classList.remove('is-on'); }
        if (el < ms + 2500 && (P.length || el < ms)) requestAnimationFrame(f); else { cv.c.remove(); ov.remove(); }
      })(t0);
    },
    fireworks: function (ms) {
      if (SB._calm()) return;
      ms = ms || 3200; SB._css();
      var fl = document.createElement('div'); fl.className = 'sb-flash'; document.body.appendChild(fl);
      var cv = SB._canvas(), x = cv.x, W = cv.W, H = cv.H, R = [], S = [], t0 = performance.now();
      function rocket() {
        R.push({ x: W * (.15 + Math.random() * .7), y: H + 10, vy: -(H * .018 + Math.random() * 4), ty: H * (.15 + Math.random() * .3), c: SB.COLORS[(Math.random() * 7) | 0] });
      }
      function boom(r) {
        var count = 70 + (Math.random() * 30 | 0), c2 = SB.COLORS[(Math.random() * 7) | 0];
        for (var i = 0; i < count; i++) {
          var a = (i / count) * Math.PI * 2, v = 2.5 + Math.random() * 4.5;
          S.push({ x: r.x, y: r.y, px: r.x, py: r.y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, c: i % 2 ? r.c : c2, l: 1, d: .012 + Math.random() * .012 });
        }
        fl.classList.remove('go'); void fl.offsetWidth; fl.classList.add('go');
      }
      rocket(); var iv = setInterval(function () { if (performance.now() - t0 < ms - 900) { rocket(); if (Math.random() > .5) rocket(); } }, 420);
      (function f(now) {
        var el = now - t0; x.clearRect(0, 0, W, H); x.globalCompositeOperation = 'lighter';
        R = R.filter(function (r) {
          r.y += r.vy; r.vy *= .985;
          x.fillStyle = r.c; x.beginPath(); x.arc(r.x, r.y, 2.6, 0, 6.3); x.fill();
          x.fillStyle = 'rgba(255,220,150,.5)'; x.fillRect(r.x - 1, r.y, 2, 14);
          if (r.y <= r.ty || r.vy > -1.5) { boom(r); return false; } return true;
        });
        S.forEach(function (p) {
          p.px = p.x; p.py = p.y; p.vy += .06; p.vx *= .985; p.vy *= .985; p.x += p.vx; p.y += p.vy; p.l -= p.d;
          x.globalAlpha = Math.max(0, p.l); x.strokeStyle = p.c; x.lineWidth = 2.2; x.beginPath(); x.moveTo(p.px - p.vx * 2, p.py - p.vy * 2); x.lineTo(p.x, p.y); x.stroke();
          if (Math.random() < .08) { x.fillStyle = '#fff'; x.fillRect(p.x, p.y, 1.6, 1.6); }
        });
        x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
        S = S.filter(function (p) { return p.l > 0; });
        if (el > ms) clearInterval(iv);
        if (el < ms || R.length || S.length) requestAnimationFrame(f); else { clearInterval(iv); cv.c.remove(); fl.remove(); }
      })(t0);
    },
    gift: function (t, m, b) {
      var name = SB.name(t, m, b);
      SB.modal(
        '<p style="margin:0 0 12px;color:#6c7678;font-size:14px">Send <b style="color:#0f3a38">' + SB.esc(name) + '</b> to someone. They get a link to their blend with your note.</p>' +
        '<label class="sb-field"><span>To</span><input name="to" maxlength="30" placeholder="Their name"></label>' +
        '<label class="sb-field"><span>From</span><input name="from" maxlength="30" placeholder="Your name"></label>' +
        '<label class="sb-field"><span>Note (optional)</span><textarea name="note" maxlength="140" placeholder="Made this one for you"></textarea></label>' +
        '<button type="button" class="sb-btn" data-send style="width:100%">Send gift link</button>' +
        '<button type="button" class="sb-btn ghost" data-buy style="width:100%;margin-top:8px">Buy it for them (' + SB.money(SB.price(t, m, b)) + ')</button>' +
        '<p style="font-size:12px;color:#8b9294;margin:10px 0 0">Buying it? Enter their address at checkout. Your note is saved on the order.</p>',
        'Gift this blend',
        function (box, close) {
          var v = function (n) { return (box.querySelector('[name="' + n + '"]').value || '').trim(); };
          box.querySelector('[data-send]').onclick = function () {
            var url = SB.link(t, m, b, { to: v('to'), from: v('from'), note: v('note') });
            var text = (v('to') ? v('to') + ', ' : '') + (v('from') || 'Someone') + ' made you a blend: "' + name + '"';
            if (navigator.share) navigator.share({ title: name, text: text, url: url }).catch(function () {});
            else SB.copy(url);
          };
          box.querySelector('[data-buy]').onclick = function () {
            var to = v('to'), note = v('note');
            close(); SB.addTrio(t, m, b, { 'Gift for': to, 'Gift note': note }).catch(function () {});
          };
        }
      );
    }
  };
  window.SmllBlends = SB;
})();
